export const isTypedModalShown = (state) => state.typedModalState.isShown;

export const getModalType = (state) => state.typedModalState.type;

export const getModalData = (state) => state.typedModalState.data;

export const getTypedModalState = (state) => state.typedModalState;
